// extracted by mini-css-extract-plugin
module.exports = {"favorite":"Favorites_favorite__3dWRT"};